<script>

import { Overlay } from '../../'

export default {
    name: 'FRAMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'FRAMA - Fractal Adaptive Moving Average',
                preset: {
                    name: 'FRAMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#e91e63'
                    }
                }
            }
        },
        use_for() { return ['FRAMA'] },
        calc() {
            return {
                props: {
                    length: { def: 16, text: 'Length' },
                    fc: { def: 1, text: 'FC' },
                    sc: { def: 198, text: 'SC' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let count = Math.max(2, 2 * Math.floor(length / 2)), half = count / 2
                    let average = ts(NaN)
                    let top1 = -Infinity, top2 = -Infinity, low1 = Infinity, low2 = Infinity
                    for (let i = 0; i < half; i++) {
                        top1 = Math.max(top1, high[i]); low1 = Math.min(low1, low[i])
                        top2 = Math.max(top2, high[i + half]); low2 = Math.min(low2, low[i + half])
                    }
                    let n1 = (top1 - low1) / half, n2 = (top2 - low2) / half
                    let n3 = (Math.max(top1, top2) - Math.min(low1, low2)) / count
                    let dimension = n1 + n2 > 0 && n3 > 0 ? Math.log((n1 + n2) / n3) / Math.log(2) : 1
                    let minimum = 2 / (sc + 1), maximum = 2 / (fc + 1)
                    let alpha = Math.max(minimum, Math.min(maximum, Math.exp(Math.log(minimum) * (dimension - 1))))
                    average[0] = Number.isFinite(average[1]) && Number.isFinite(alpha) ? alpha * close[0] + (1 - alpha) * average[1] : close[0]
                    return average[0]
                `
            }
        }
    }
}
</script>
